import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from 'crm/common/api/customer-info'

export async function detail(payload) {
    return request(
        `${format(api.detail.url, {id: payload.id})}${stringify(payload.params, {
            addQueryPrefix: true,
        })}`,
    )
}

export async function followUsers(payload) {
    return request(format(api.followUsers.url, {external_userid: payload.externalUserId}))
}

export async function customerChats(params) {
    return request(`${api.customerChats.url}${stringify(params, {addQueryPrefix: true})}`)
}
